import styles from './billHelpAccordion.scss';
import ReactHtmlParser from 'react-html-parser';
 
class myAccountAccordion extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      headerSelected: null, subheaderSelected: null, questionSelected: null, faqSections: [],
      General: this.props.isSavingsPopup || this.props.isNemNbt || this.props.isCCAPopup,
      myProgAccr: this.props.isMyprogram && !this.props.isNemNbt && !this.props.isCCAPopup && this.props.isSavingsPopup,
      nemAccr: this.props.isNemAcct && !this.props.isCCAPopup,
      mbl: this.props.isMbl && this.props.isSavingsPopup,
    };
    this.arrowIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/dss_chev_down.svg';
    this.arrowIconUp = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/dss_chev_up.svg';
  }
  componentDidMount() {       
    this.getBillHelpFaqs();
} 
componentWillReceiveProps(){
  if(!this.props.isBillPopUpOpen){
  this.setState({headerSelected: null, subheaderSelected: null, questionSelected: null, faqSections: []});}
}

  getBillHelpFaqs = () => {
      let sections = [];
      if(!_.isEmpty(this.props.content)) {
        let staticContent = this.props.content;
        let faqRegex = new RegExp('<main class="dss-faqs">([^`]*?)</main>', "g");
        let faqs = staticContent.match(faqRegex);
        faqs = faqs ? faqs[0] : '';
        let sectionRegex = new RegExp('<section class="([^`]*?)">([^`]*?)</section>', "g");
        sections = faqs.match(sectionRegex);
      }
      return sections ? sections : [];
   }
  checkDisplayEligibilityAlt = (secType) => {
    switch (secType) {
      case "pbDeEnrolled": return this.props.obStatus === "ObDeEnroll";
      case "pbEnrolled": return this.props.pbEnrolled;
      case "dpEnrolled": return this.props.dpEnrolled;
      case "dpDeEnrolled": return this.props.dpStatus === "DpDeEnroll";
      case "jointSepEnrolled": return this.props.isSavingsPopup && this.props.isSepEnrolled;
      case "jointSepDeEnrolled": return this.props.isSavingsPopup && !this.props.isSepEnrolled;
      case "jointCareferaEnrolled": return this.props.careFeraAccordian && this.props.isIqpEnrolled;
      case "jointCareferaDeEnrolled": return this.props.careFeraAccordian && !this.props.isIqpEnrolled;
      case "jointSdpEnrolled": return this.props.isSavingsPopup && this.props.isSdpEnrolled;
      case "jointSdpDeEnrolled": return this.props.isSavingsPopup && !this.props.isSdpEnrolled;
      default: return true;
    }
  }
   checkDisplayEligibility = (secType) => {
      switch(secType) {
        case "cca": return this.props.customerType === "E" && !app.appService.getSessionstorage('isAccountDA');
        case "sdp": return this.props.isSdpEligible;
        case "nem": return this.state.nemAccr;
        case "sbp": return this.props.isNbtAcct;
        case "sep": return this.props.isSepEligible;
        case "jointBbp": return this.props.isBbp;
        case "general": return !this.state.General;
        case "jointPa": return this.props.isPa;   
        case "mbl": return this.state.mbl;     
        case "myprogram": return this.state.myProgAccr;
        case "sceRates" : return !this.props.isSingle;
        default: return true;
      }
   }

   urlCheck = () =>{
    switch(window.location.pathname){
        case '/mysce/myaccount':
            return 'dashboard';
        case'/mysce/settings':
            return 'settings';
        case '/mysce/billsnpayments':
            return 'billsnpayments';
    }
}
 
  /* To expand and collapse toggle */
  accordionToggle = (index, accordion, heading, subHeading, answers) => {
    let url = this.urlCheck();
    switch (accordion) {
      case "Header":
        if(this.state.headerSelected === index) {
          window.aUtils ? window.aUtils.sendAAEvent(`faq`, `${url}|none|none|bill_help|modal|collapse - ${heading}`) : null;
          this.setState({ headerSelected: null });
        }else{
          this.setState({ headerSelected: index, subheaderSelected: null, questionSelected: null });
          window.aUtils ? window.aUtils.sendAAEvent(`faq`, `${url}|none|none|bill_help|modal|expand - ${heading}`) : null;
        }  
        break;
      case "subHeader":
        if(this.state.subheaderSelected === index){
          window.aUtils ? window.aUtils.sendAAEvent(`faq`, `${url}|none|none|bill_help|modal|collapse - ${subHeading}`): null;
          this.setState({ subheaderSelected: null });
        }else{
          window.aUtils ? window.aUtils.sendAAEvent(`faq`, `${url}|none|none|bill_help|modal|expand - ${subHeading}`) : null;
          this.setState({ subheaderSelected: index, questionSelected: null });
        } 
        break;
      case "question":
        if(this.state.questionSelected === index){
          window.aUtils ? window.aUtils.sendAAEvent(`faq`, `${url}|none|none|bill_help|modal|collapse - ${answers}`) : null;
          this.setState({ questionSelected: null });
        }else{
          window.aUtils ? window.aUtils.sendAAEvent(`faq`, `${url}|none|none|bill_help|modal|expand - ${answers}`) : null;
          this.setState({ questionSelected: index });
        } 
        break;
    }
  }
  /* To show arrow upwards and downwards based on index */
  showArrow = (index, accordion) => {
    const headerAccordionArrow = (accordion === 'header' && this.state.headerSelected === index);
    const subHeaderAccordionArrow = (accordion === 'subheader' && this.state.subheaderSelected === index);
    const questionAccordionArrow = (accordion === 'question' && this.state.questionSelected === index);
    const directQuesAccordionArrow = (accordion === 'directQuestion' && this.state.questionSelected === index);
    return (
      <span className={accordion==='subheader' || accordion==='question'?styles.arrowAlignSubheader: styles.arrowAlign}> {headerAccordionArrow || subHeaderAccordionArrow || questionAccordionArrow || directQuesAccordionArrow ? (
        <span>
          <i data-aa-event="accordion" />
          {headerAccordionArrow || directQuesAccordionArrow ? <img src={this.arrowIconUp} alt="up arrow" /> : <img className={styles.upArrow} src={this.arrowIcon} alt="up arrow" />}
        </span>
      ) : (
          <span> <i data-aa-event="accordion" />
            <img src={this.arrowIcon} alt="down arrow" />
          </span>
        )}
      </span>);
  }

  getQAs = (item, isLevelTwo=false) => {    
    const subHeaderAccordion = Object.values(item.questions);
    const answerAccordion = Object.values(item.answers);
    const subHeaderAccordionRender = subHeaderAccordion.map((subHeader, index, subHeaderAccordion) => {
    const answerAccordionRender = answerAccordion[index];
    //Changes Implemented for SEP Card Enablement – Commercial Users
      return (
        <div className={!isLevelTwo ? styles.sceBillHelpQaSec : ''}>
          <div className={styles.sceBillHelpEachQaSec}>
          {answerAccordionRender===undefined?<a href="javascript:void(0)" className={[styles.sceBillHelpQSec,styles.sceAnchorStyleUpdate].join(" ")}>
              <div>{ReactHtmlParser(subHeader)}</div>
            </a>:<a href="javascript:void(0)" className={[styles.sceBillHelpQSec,styles.sceAnchorStyleUpdate].join(" ")} onClick={() => this.accordionToggle(index, 'question', '', '', ReactHtmlParser(subHeader))}>
              <div>{ReactHtmlParser(subHeader)}</div> 
              <div className={styles.sceBillHelpQSecArrow}>{this.showArrow(index, 'question')}</div>
            </a>}
            <div className={this.state.questionSelected === index ? styles.contentShow : styles.content}>
              <div className={styles.sceBillHelpAnsSec}>{ReactHtmlParser(answerAccordionRender)}</div>
            </div>
          </div>
          {index !== subHeaderAccordion.length-1 ? <div className={styles.sceBillHelpDivider} /> : null}
        </div>
      );
    });
    return subHeaderAccordionRender;
  }

  /* to show sub headers in an accordion */
  subHeaders = (item) => {
    if (item.subHeader) {
      return item.subHeader.map((eachSubHeader, index, subHeader)=>{
        return (
          <div className={styles.sceBillHelpQaSec}>
            <div className={styles.sceBillHelpEachQaSec}>
              <a href="javascript:void(0)" className={[styles.sceBillHelpQSec,styles.sceAnchorStyleUpdate].join(" ")} onClick={() => this.accordionToggle(index, 'subHeader','', eachSubHeader.header)}>
                <div>{ReactHtmlParser(eachSubHeader.header)}</div> 
                <div className={styles.sceBillHelpQSecArrow}>{this.showArrow(index, 'subheader')}</div>
              </a>
              <div className={this.state.subheaderSelected === index ? styles.contentShow : styles.content}>
                {this.getQAs(eachSubHeader, true)}
              </div>
            </div>
            {index !== subHeader.length-1 ? <div className={styles.sceBillHelpDivider} /> : null}
          </div>          
        );
      });
    } else {
       return this.getQAs(item);
    }
  }

  getSubHeaderContent(subHeaderSections) {
    let subHeadersContent = [];
    subHeaderSections.forEach((eachSec)=>{
      let secTypeRegex = new RegExp('<div class="(.*?)">([^`]*?)</div>', 'g');
      let headerRegex = new RegExp('<p class="dssfaq-subheader">(.*?)</p>', 'g');
      let quesRegex = new RegExp('<p class="dssfaq-question">(.*?)</p>', 'g');
      let ansRegex = new RegExp('<p class="dssfaq-answer">(.*?)</p>', 'g');

      let secType = secTypeRegex.exec(eachSec);
      secType = secType[1] ? secType[1].split('-')[1] : '';
      if(secType.includes("Enrolled") ? this.checkDisplayEligibilityAlt(secType) : this.checkDisplayEligibility(secType)) {
        headerRegex.lastIndex = 0;
        let header = headerRegex.exec(eachSec);
        header = header[1] ? header[1] : '';
          
        let questions = eachSec.match(quesRegex).map(val => {
          quesRegex.lastIndex = 0;
          let question = quesRegex.exec(val);
          return question[1] ? question[1] : '';
        });
        let answers = eachSec.match(ansRegex) .map(val => {
            ansRegex.lastIndex = 0;
            let answer = ansRegex.exec(val);
            return answer[1] ? answer[1] : '';
        });

        subHeadersContent.push({
          header: header, questions: questions, answers: answers
        });
      }      
    });
    return subHeadersContent;
  }

  getDisplayContent = () => {
    let displayContent = [];
    let faqSections = this.getBillHelpFaqs();
    faqSections.forEach((eachSec) =>{
        let secTypeRegex = new RegExp('<section class="(.*?)">([^`]*?)</section>', 'g');
        let headerRegex = new RegExp('<p class="dssfaq-header">(.*?)</p>', 'g');
        let subHeaderSecRegex = new RegExp('<div class="dssfaq-([^`]*?)">([^`]*?)</div>', 'g');
        let quesRegex = new RegExp('<p class="dssfaq-question">(.*?)</p>', 'g');
        let ansRegex = new RegExp('<p class="dssfaq-answer">(.*?)</p>', 'g');

        let secType = secTypeRegex.exec(eachSec);
        secType = secType[1] ? secType[1].split('-')[1] : '';
        if(secType.includes("Enrolled") ? this.checkDisplayEligibilityAlt(secType) : this.checkDisplayEligibility(secType)) {
          headerRegex.lastIndex = 0;
          let header = headerRegex.exec(eachSec);
           header = header[1] ? header[1] : '';

          let subHeaderSections = eachSec.match(subHeaderSecRegex);
          let subHeadersContent = [];
          if(!_.isEmpty(subHeaderSections)) {
            subHeadersContent = this.getSubHeaderContent(subHeaderSections) ;
            if(!_.isEmpty(subHeadersContent)) {
              displayContent.push({
                  header: header, subHeader: subHeadersContent
              });
            }
          } else {  
            let questions = eachSec.match(quesRegex).map(val => {
                quesRegex.lastIndex = 0;
                let question = quesRegex.exec(val);
                return question[1] ? question[1] : '';
            });
            let answers = eachSec.match(ansRegex) .map(val => {
                ansRegex.lastIndex = 0;
                let answer = ansRegex.exec(val);
                return answer[1] ? answer[1] : '';
            });
            displayContent.push({
                header: header, questions: questions, answers: answers, secType: secType
            });
          }
        }
    });
    return displayContent;
  }
  displayBillHelp(item, index){
    let ignoreList = item.secType === "cca" || item.secType === "nem" || item.secType === "sbp";
    let ignoreCondition = this.props.isCCAPopup || this.props.isNemNbt;
    let thisLoc = this;
    if(!ignoreList && !ignoreCondition){
      return (
        <div className={styles.item}>
                  <div className={thisLoc.state.headerSelected === index ? styles.sceBillHelpHeaderSel : styles.sceBillHelpHeader} onClick={() => this.accordionToggle(index, 'Header', item.header)}>
                  <a href="javascript:void(0)" className={[styles.title,styles.sceAnchorStyleUpdate].join(" ")}>
                    <div className={styles.sceAccordionText}>
                      <div>{item.header} </div>
                      {thisLoc.showArrow(index, 'header')}
                    </div>
                  </a></div>
                  <div className={thisLoc.state.headerSelected === index ? styles.contentShow : styles.content}>
                    {thisLoc.subHeaders(item)}
                  </div>
        </div>
      );
    }
    else if(ignoreList && ignoreCondition){
      return item.questions.map((ques, ind)=>{
              return (
              <div className={styles.item}>
                      <div className={thisLoc.state.questionSelected === ind ? styles.sceBillHelpHeaderSel : styles.sceBillHelpHeader} onClick={() => thisLoc.accordionToggle(ind, 'question','', '', ReactHtmlParser(item.question))}>
                      <a href="javascript:void(0)" className={[styles.title,styles.sceAnchorStyleUpdate].join(" ")}>
                        <div className={styles.sceAccordionText}>
                          <div>{ques} </div>
                          {thisLoc.showArrow(ind, 'directQuestion')}
                        </div>
                      </a></div>
                       <div className={thisLoc.state.questionSelected === ind ? styles.answerShow : styles.answer}>
                          <div className={styles.sceBillHelpAnsSec}>{ReactHtmlParser(item.answers[ind])}</div>
                        </div>
            </div>
            );
          });}
    else{
      return null;}}
  render() {
    let displayContent = this.getDisplayContent();
    return (
      <div>
        <div className={styles.accordion} >
          <div>
            {displayContent.map((item, index) => (
              this.displayBillHelp(item, index)
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default myAccountAccordion;